import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Query business analytics info
 */
export default async function queryBusinessAnalyticsInfo(): Promise<DataDashBoardData> {
  const res = await fetchOrchidAPI(
    "/api/scheduler/v1/data_dashboard/dashboard/pastyear",
  );
  if (!res.ok) {
    throw new Error(
      `failed to get business info: ${getErrorDetail(await res.text())}`,
    );
  }

  return res.json();
}
